import { SerializedSocialChannel } from '../types';

/**
 * The remote connect flags of the channel answer (owner rule 2026-10-27). The web knows nothing
 * about the posting partner itself: the server says where a new connect goes, so a platform can
 * move back to our own app with no web release. An older API sends no flags: no partner, no lock.
 */

/** The name of the posting partner of the next connect, or null (our own app). */
export function channelConnectPartnerName(channel: SerializedSocialChannel): string | null {
  if (channel.connectVia !== 'partner') {
    return null;
  }
  const name = channel.connectPartnerName ?? null;
  return name === null || name === '' ? null : name;
}

/** True when the next connect needs a paid plan: the card locks Connect and opens the plan offer. */
export function channelConnectNeedsPaidPlan(channel: SerializedSocialChannel): boolean {
  return channel.connectNeedsPaidPlan === true;
}

/** The server's sentence why the channel must sign in again, or null. */
export function channelReconnectReason(channel: SerializedSocialChannel): string | null {
  const reason = channel.reconnectReason ?? null;
  return reason === null || reason === '' ? null : reason;
}
